import { ReactFlowState } from '@xyflow/react';
import { useCallback } from 'react';

import { useFlowChartContext } from '../context/flowChart.context';
import { useGetValue } from './internal/useGetValue';

const isInteractiveSelector = (s: ReactFlowState) =>
  s.nodesDraggable && s.nodesConnectable;

export function useIsInteractive() {
  const { editable } = useFlowChartContext();
  const {
    store,
    value: isInteractive,
    get: getIsInteractive,
  } = useGetValue(isInteractiveSelector);

  const toggleIsInteractive = useCallback(() => {
    if (editable !== undefined) return;
    store.setState({
      nodesDraggable: !isInteractive,
      nodesConnectable: !isInteractive,
    });
  }, [editable, isInteractive, store]);

  const getInteractive = useCallback(
    () => editable ?? getIsInteractive(),
    [editable, getIsInteractive]
  );
  return {
    isInteractive: editable ?? isInteractive,
    toggleIsInteractive,
    getIsInteractive: getInteractive,
  };
}
